module.exports = __webpack_public_path__ + "ea71ebdd05e573b9925fc2faa8aa6d5e.svg";